import { createGlobalStyle } from "styled-components";

const RobotoFont = createGlobalStyle`

@font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url(./styles/fonts/KFOlCnqEu92Fr1MmSU5vAw.ttf) format('truetype');
  }
`;

export default RobotoFont;